<template>
	<span>
		<a
			v-if="parsedButton.button_scenario === 'alumni_button' && isAlumni"
			:href="parsedButton.button_url"
			:class="parsedButton.style"
			target="_blank"
			rel="nofollow noopener"
		>
			{{ parsedButton.button_title }}
		</a>

		<a
			v-if="parsedButton.button_scenario === 'external_link'"
			:href="parsedButton.button_url"
			:class="parsedButton.style"
			target="_blank"
			rel="nofollow noopener"
		>
			{{ parsedButton.button_title }}
		</a>
		<a
			v-if="parsedButton.button_scenario === 'internal_link'"
			:href="parsedButton.button_url"
			:class="parsedButton.style"
		>
			{{ parsedButton.button_title }}
		</a>
		<a
			v-if="parsedButton.button_scenario === 'help'"
			role="button"
			onclick="return jivo_api.open(),!1"
			href="javascript:void(0)"
			:class="parsedButton.style"
		>{{ parsedButton.button_title }}</a>

		<button
			v-if="parsedButton.button_scenario === 'video'"
			href="javascript:void(0)"
			:class="parsedButton.style"
			@click="playVideo()"
		>{{ parsedButton.button_title }}</button>

		<CoolLightBox
			v-if="parsedButton.button_scenario === 'video'"
			:items=" [{
				src: parsedButton.button_url,
			}]"
			:full-screen="true"
			:index="indexVideosSource"
			@close="indexVideosSource = null"
		/>

		<a
			v-if="parsedButton.button_scenario === 'payment_form'"
			v-scroll-to="'#empty-registration'"
			href="#"
			:class="parsedButton.style"
		>
			{{ parsedButton.button_title }}
		</a>
	</span>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import { mapGetters } from 'vuex';

export default {
	name: 'PanelButtons',
	components: {
		CoolLightBox,
	},
	props: {
		block: { type: Object, default: () => null },
		content: { type: String, default: () => null },
	},
	data() {
		return {
			indexVideosSource: null,
		};
	},
	computed: {
		...mapGetters({
			isAlumni: 'profile/isAlumni',
		}),
		parsedButton() {
			if (!this.content) return this.block ? this.block.buttons : [];
			const {
				scenario: button_scenario, url: button_url, title: button_title, class: style,
			} = JSON.parse(this.content);

			return {
				button_scenario,
				button_url,
				button_title,
				style,
			};
		},

	},
	methods: {
		playVideo(index = 0) {
			this.indexVideosSource = index;
		},
	},
};
</script>
